import { createTheme } from '@mui/material/styles';

import breakpoints from 'utils/breakpoints';
import { getColor } from 'utils/colors';
import mixins from 'utils/mixins';
import { remCalc } from 'utils/remCalc';

const theme = createTheme({
	breakpoints: breakpoints,
	mixins: mixins,
});

export const styles = {};

export const overrides = {
	'.listingDetails': {
		'.listingDetails__logo': {
			display: 'flex',
			justifyContent: 'center',
			alignItems: 'center',
			textAlign: 'center',
			paddingTop: remCalc(40),
			paddingBottom: remCalc(40),
		},
		'.listingDetails__content': {
			color: getColor('ivory', 700),
		},
		'.listingDetails__subheader': {
			fontFamily: 'var(--font-brandon-grotesque)',
			fontSize: remCalc(32),
			fontWeight: 400,
			lineHeight: 1.25,
			letterSpacing: remCalc(-0.32),

			textTransform: 'uppercase',
			paddingBottom: remCalc(16),
			[theme.breakpoints.up('sm')]: {
				paddingBottom: remCalc(32),
			},
		},
		'.listingDetails__amenities, .listingDetails__description': {
			'> ul, > p': {
				color: getColor('ivory', 700),
				fontFamily: 'var(--font-avenir-next)',
				fontSize: remCalc(16),
				fontWeight: 500,
				lineHeight: 1.4,
				letterSpacing: remCalc(0.5),
			},
			padding: remCalc("40px 0"),
			'.listingDetails__amenitiesList': {
				paddingLeft: remCalc(16),
				marginTop: 0,
				marginBottom: remCalc(16),
				[theme.breakpoints.up('sm')]: {
					marginBottom: remCalc(22),
				}
			}
		},
		'.listingDetails__gallery_container': {
			'.imageSlider__container': {
				paddingTop: remCalc(40),
				paddingBottom: remCalc(40),
				margin: 0,
			},
			'.imageSlider__container .imageSlider': {
				aspectRatio: '1.78/1',
			}
		},
		'.listingDetails__threshold360_container': {
			paddingTop: remCalc(40),
			paddingBottom: remCalc(40),
		},
		'.listingDetails__map': {
			paddingTop: remCalc(40),
			paddingBottom: remCalc(40),
			'> div:nth-of-type(2)': {
				textAlign: 'right',
				[theme.breakpoints.down('md')]: {
					textAlign: 'left',
				}
			},
		},
		'.listingDetails__directionsButton': {
			display: 'inline-flex',
			justifyContent: 'flex-end',
			alignItems: 'center',
			textTransform: 'uppercase',
			textDecoration: 'none',

			color: getColor('ivory', 600),
			fontSize: remCalc(20),
			fontStyle: 'normal',
			fontWeight: 420,
			lineHeight: 1.2,
			letterSpacing: remCalc(2),

			borderBottom: `1px solid ${getColor('ivory', 700)}`,
			transition: 'border-color var(--transition-duration) ease',

			'.listingDetails__directionsButton__arrow': {
				width: 0,
				height: remCalc(12),
				opacity: 0,
				marginLeft: 0,
				overflow: 'hidden',
				transform: 'translateX(-6px)',
				transition: 'width  var(--transition-duration) ease, margin-left  var(--transition-duration) ease, opacity  var(--transition-duration-slow) ease, transform  var(--transition-duration) ease',

				'svg': {
					display: 'block',
					width: remCalc(47),
					height: remCalc(12),
				},

				'svg path': {
					fill: getColor('ivory', 700),
				},
			},

			'&:focus-visible .listingDetails__directionsButton': {
				borderBottom: `1px solid ${getColor('ivory', 700)}`,
			},

			'&:focus-visible .listingDetails__directionsButton__arrow': {
				width: remCalc(47),
				marginLeft: remCalc(16),
				opacity: 1,
				transform: 'translateX(0)',
			},

			'@media (hover: hover) and (pointer: fine)': {
				'&:hover .listingDetails__directionsButton': {
					borderBottom: `1px solid ${getColor('ivory', 700)}`,
				},
				'&:hover .listingDetails__directionsButton__arrow': {
					width: remCalc(47),
					marginLeft: remCalc(16),
					opacity: 1,
					transform: 'translateX(0)',
				},
			},

			[theme.breakpoints.down('md')]: {
				justifyContent: 'flex-start',
			}
		}
	}
};

export default styles;